//用于存新闻列表
const state = {
  newsList:[]
}
const getters = {
  getAllNewList: state=>{
    return state.newsList
  },
  getNewById:(state)=>(id)=>{
    return state.newsList.find((newItem)=>newItem.id === id)
  }
}
const mutations = {
  Update_NewsList(state,newsList){
    state.newsList = newsList.slice()
  }
}
const actions = {
 
}
export default {
  state, 
  getters,
  mutations,
  actions
}
